
export const getComments = ({ commentsReducer: { comments = [] } = {} }) => comments;
export const getCommentFilter = ({ commentsReducer: { filter = {} } = {} }) => filter;
export const getCommentsCount = ({ commentsReducer: { count = 0 } = {} }) => count;
